// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetConsultingCasesByUserRequestModel from '../../model/get-consulting-cases-by-user-request-model';
import GetConsultingCasesByUserRequestDTO from '../dto/get-consulting-cases-by-user-request-dto';
import dtoSchema from '../schemas/get-consulting-cases-by-user-request-schema';

export default abstract class GetConsultingCasesByUserRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetConsultingCasesByUserRequestDTO>) {
    super();
    if (data) {
      this.userId = data.userId;
    }
  }
  /**
  * @type {int64}
  */
  userId?: number;

  static toModel(dto: DeepPartial<GetConsultingCasesByUserRequestDTO>): GetConsultingCasesByUserRequestModel;
  static toModel(dto: DeepPartial<GetConsultingCasesByUserRequestDTO> | undefined | null): GetConsultingCasesByUserRequestModel | undefined;
  static toModel(dto: DeepPartial<GetConsultingCasesByUserRequestDTO> | undefined | null): GetConsultingCasesByUserRequestModel | undefined {
    return dto ? new GetConsultingCasesByUserRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetConsultingCasesByUserRequestModel> | GetConsultingCasesByUserRequestModel): GetConsultingCasesByUserRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      userId: unwrapped.userId,
    } as GetConsultingCasesByUserRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetConsultingCasesByUserRequestModel, can not map to GetConsultingCasesByUserRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
